import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_4 = { class: "menu-item-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Table, {
        columns: _ctx.columns,
        rows: _ctx.configData,
        padding: 5,
        loading: _ctx.loader
      }, {
        "cell-site": _withCtx(({row:item}) => [
          _createTextVNode(_toDisplayString(item?.site?.name), 1)
        ]),
        "cell-country": _withCtx(({row:item}) => [
          _createTextVNode(_toDisplayString(item?.country?.name), 1)
        ]),
        "cell-locale": _withCtx(({row:item}) => [
          _createTextVNode(_toDisplayString(item?.country?.locale), 1)
        ]),
        "cell-currency": _withCtx(({row:item}) => [
          _createTextVNode(_toDisplayString(item?.country?.currency), 1)
        ]),
        "cell-actions": _withCtx(({row:item}) => [
          _createVNode("button", {
            class: "action-btn",
            type: "button",
            onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
          }, [
            _hoisted_3,
            _createVNode("div", {
              class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
            }, [
              _createVNode("div", _hoisted_4, [
                (_ctx.$can('edit_system_configuration'))
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleEdit(item)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_6,
                        _createTextVNode(_toDisplayString(_ctx.$t('message.EDIT')), 1)
                      ], 8, ["onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["columns", "rows", "loading"])
    ])
  ]))
}